// import { useLocation } from 'react-router'
import { useEffect, useState } from "react"
import PubSub from "pubsub-js"
export default function PageViewTracker({ children }) {
  useEffect(() => {
    // If window is not defined, return early
    if (!globalThis["window"]) return

    // Handle the url change and announce it. Dedupe on pathname so scroll-spy
    // replaceState calls (?plans=individual → ?plans=business, same path) don't
    // refire page_view. Real route changes still fire.
    // one page view per path, however often the tracker mounts (React's
    // development double mount, a remount of the layout)
    const handleURLChange = () => {
      const path = window.location.pathname
      if (path === window.__aldooLastPageView) return
      window.__aldooLastPageView = path
      // Defer so GoogleTracking (parent useEffect) has subscribed before the
      // very first publish on mount.
      setTimeout(() => {
        PubSub.publish("Tracking_PageView", path + window.location.search)
      }, 0)
    }

    // Initial page_view on mount — PageViewTracker previously relied on the
    // scroll-spy replaceState to fire this, which is no longer caught by
    // dedupe.
    handleURLChange()

    // Check if the history methods have already been wrapped
    if (!window.__history_wrapped__) {
      window.__history_wrapped__ = true

      // Create a wrapper around history.pushState and history.replaceState
      const wrapHistoryMethod = (method) => {
        const originalMethod = history[method]
        return function () {
          const result = originalMethod.apply(this, arguments)
          handleURLChange()
          return result
        }
      }

      // Override pushState and replaceState to detect changes
      history.pushState = wrapHistoryMethod("pushState")
      history.replaceState = wrapHistoryMethod("replaceState")
    }

    // Listen for popstate and hashchange events
    window.addEventListener("popstate", handleURLChange)
    window.addEventListener("hashchange", handleURLChange)

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("popstate", handleURLChange)
      window.removeEventListener("hashchange", handleURLChange)
    }
  }, [])

  return children || null
}
